import { useEffect, useState } from "react";
import { EDITING_SOURCE_MAP } from "../lib/helpers";

export const useBrightRiverImages = (allImages) => {
    const [corrections, setCorrections] = useState([]);

    useEffect(() => {
        const isPremiumEditSource = (editingSourceId) =>
            EDITING_SOURCE_MAP["brightRiver"] === editingSourceId || EDITING_SOURCE_MAP["brightRiverInternalPremium"] === editingSourceId;

        if (allImages) {
            const correctionShots = Object.keys(allImages).reduce((reducedShots, key) => {
                const shotsByLocale = allImages[key];

                if (shotsByLocale.length) {
                    const filteredShots = shotsByLocale.filter(
                        ({ editedBlobKey, editingSourceId }) => !!editedBlobKey && isPremiumEditSource(editingSourceId)
                    );

                    return [...reducedShots, ...filteredShots];
                }

                return reducedShots;
            }, []);

            setCorrections(correctionShots);
        }
    }, [allImages]);

    return corrections;
};
